export default __webpack_public_path__ + "media/components/AdEdit/images/facebook-share-0226dbc9613bbe0e2314ecdb4fc7b128.png";